
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import {Getter} from "vuex-class";
import MylobyAutocompleteMultiple from "@/components/generic/autocomplete-multiple.vue";

@Component({
  components: {
    MylobyAutocompleteMultiple,
  },
})
export default class AddNonTransferablesModal extends Vue {
    @Prop({ default: null})
    public groupId: number;

    @Prop({ default: false })
    public displayModal: boolean;

    @Prop({ default: false })
    public buildingId: number;

    private loadingAdd: boolean = false;
    private selectedNonTransferables: any[] = [];

    @Getter private isMobile: boolean;
    @Getter private envCompanyId: number|null;

    private mounted(): void {
      //
    }

    private fetchNonTransferables({search, page, itemsPerPage}: { search: string, page: number, itemsPerPage: number },
    ): Promise<{ count: number; rows: any[] }> {
      return this.$store.dispatch("companies/getNonTransferables", {
        id: this.envCompanyId,
        query: {
          search,
          page,
          itemsPerPage,
          buildingId: this.buildingId,
        },
      });
    }

    private async addNonTransferables(): Promise<void> {
        this.loadingAdd = true;
        await this.$store.dispatch("keyGroups/addNonTransferables", {
            id: this.groupId,
            nonTransferableIds: this.selectedNonTransferables.map(({id}) => id),
        }).then(() => {
            this.$store.commit("alerts/displaySuccess", {
              msg: this.$i18n.t("keyGroup.addNonTransferables.successMessage"),
            });
            this.closeEdit();
            this.$emit("reset");
        }).catch((error) => {
            this.$store.commit("alerts/displayHttpError", { error });
        }).finally(() => {
            this.loadingAdd = false;
        });
    }

    private closeEdit(): void {
        this.selectedNonTransferables = [];
        this.$emit("close");
    }
}
